import { useEffect } from 'react';
import * as Authentication from '../../features/authentication/authentication-slice';
import { useLoginMutation, LoginForm } from '../../features/api/authentication-api';
import { describeApiError } from '../../features/api/errors';
import { store } from '../../store';
import './Login.scss';
import { useForm } from 'react-hook-form';
import Button from "react-bootstrap/Button";
import Spinner from "../Spinner";

interface LoginProps {
    registerClicked: () => void;
    loginSuccess: () => void;
    notice?: string;
}

function Login(props: LoginProps) {
    const [login, loginResult] = useLoginMutation();
    const busy = loginResult.isLoading;

    const {
        register,
        handleSubmit,
        formState: { errors },
        setError,
        watch,
        clearErrors
    } = useForm<LoginForm>();

    useEffect(() => {
        const subscription = watch(() => clearErrors("root.server"));
        return () => subscription.unsubscribe();
    }, [watch, clearErrors]);

    const onSubmit = (data: LoginForm) => {
        if (busy) return;
        return login({email: data.email, password: data.password} as LoginForm).unwrap().then((result) => {
            store.dispatch(Authentication.login({newState: {...result, id: result.id == null ? null : String(result.id)}}));
            props.loginSuccess();
        }).catch((error: any) => {
            setError("root.server", {type: "server", message: describeApiError(error, "login")});
        });
    };

    return <div className="card bg-light auth-box" id='login-box'>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <h2>Sign in</h2>
            {props.notice ? <div className="alert alert-success py-2" role="status">{props.notice}</div> : null}
            <div className="mb-2">
                <label htmlFor='email' className="form-label">Email</label>
                <input className="form-control" id="email" autoComplete="email" disabled={busy}
                       {...register("email", { required: "Email is required" })} type='email' />
                <span className="error-msg">{errors.email?.message?.toString()}</span>
            </div>
            <div className="mb-2">
                <label htmlFor='password' className="form-label">Password</label>
                <input className="form-control" id="password" autoComplete="current-password" disabled={busy}
                       {...register('password', { required: "Password is required" })} type='password' />
                <span className="error-msg">{errors.password?.message?.toString()}</span>
            </div>

            {errors.root?.server ? <div className="alert alert-danger py-2" role="alert">{errors.root.server.message}</div> : null}

            <div className='bottom-buttons'>
                <Button id="submit" type="submit" disabled={busy}>
                    {busy ? <><Spinner/>Signing in…</> : "Sign in"}
                </Button>
                <hr />
                <Button variant="secondary" disabled={busy} onClick={() => props.registerClicked?.()}>Create new account</Button>
            </div>
        </form>
    </div>;
}

export default Login;
